import React from 'react';
import { TColumn } from './types';
import { CapitalizeNames } from 'src/utils/capitalize';

interface IAccessLevelRow {
    column: TColumn;
    item: any;
}

export const AccessLevelRow = ({ item }: IAccessLevelRow) => {
    return <span>{CapitalizeNames(item?.accessLevel || '- - -')}</span>;
};
